import { render, staticRenderFns } from "./InvoiceIcon.vue?vue&type=template&id=ac8aa08a&"
import script from "./InvoiceIcon.vue?vue&type=script&lang=js&"
export * from "./InvoiceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports